import type { IInfoBoxVariantValuesType } from ".";

export const infoBoxVariantValues: IInfoBoxVariantValuesType = {
  info: {
    icon: "InfoSquare",
    fullWidth: true,
  },
  noData: {
    icon: "CloundCross",
  },
};
